export default {"src":"/_next/static/media/decorate.9fbbdbf2.svg","height":604,"width":732};